import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type CreateDormakabaKeyRequest = {
  clientId: string
  commonAreaIds?: number[]
}

const createDormakabaKey = async (data: CreateDormakabaKeyRequest) => {
  const response = await authAPI.post('/dormakaba/client', data)
  return response.data
}

export const useCreateDormakabaKey = () =>
  useMutation({
    mutationFn: createDormakabaKey,
  })
